import { render, staticRenderFns } from "./transaccion-table.vue?vue&type=template&id=23f9ebfd&"
import script from "./transaccion-table.vue?vue&type=script&lang=ts&"
export * from "./transaccion-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports